export const theme = {
  primary: window.config.theme.primary,
  secondary: window.config.theme.secondary,
  white: "#FFFFFF",
  gray: "#151515",

  fontSizeXXs: '0.625rem', // 10px
  fontSizeXs: '0.75rem', // 12px
  fontSizeSm: '0.875rem', // 14px
  fontSizeMd1: '1rem', // 16px
  fontSizeMd2: '1.125rem', // 18px
  fontSizeLg: '1.25rem', // 20px
  fontSizeXl: '1.5rem', // 24px

  fontDefault: 'Peyda',
  fontDefaultMedium: 'PeydaMedium'
};
